import React, { useState, useEffect } from "react";
import { getWishList, sendWishList } from "../../../api/api";
import { ToastContainer, toast, Zoom } from "react-toastify";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {
  Card,
  CardHeader,
  CardMedia,
  IconButton,
  Typography,
  ButtonBase,
  Grid,
  Box,
  Skeleton,
} from "@mui/material";
import "./WishList.scss";
import { useNavigate } from "react-router-dom";

const WishList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [wishlist, setWishList] = useState([]);

  useEffect(() => {
    fetchWishList();
  }, []);

  const fetchWishList = async () => {
    try {
      const response = await getWishList();
      if (response && response.data) {
        setWishList(response.data);
        setLoading(false);
      }
    } catch (error) {
      toast.error(
        error?.message
          ? error.message
          : error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
      setLoading(false);
    }
  };

  const shortListProfile = (id, is_liked) => {
    setLoading(true);
    console.log("id, is_liked", id, is_liked);
    let data = {
      is_liked: is_liked,
      short_id: Number(id),
    };
    handleUpdateWishlist(data, is_liked);
  };

  const handleUpdateWishlist = async (data, is_liked) => {
    try {
      const response = await sendWishList(data);
      let message = "";
      if (response && response.data) {
        if (is_liked) {
          message = "Profile is shortlisted successfully";
        } else {
          message = "Profile is removed successfully";
        }
        toast.success(response.message || message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        });
        fetchWishList();
        setLoading(false);
      }
    } catch (err) {
      toast.error(err.response.data.error.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        transition: Zoom,
      });
      setLoading(false);
    }
  };

  const skeletonLoader = () => {
    return [1, 2, 3, 4].map((n) => (
      <Grid item xs={12} sm={6} md={3} key={n}>
        <Card className="wishlist-card" elevation={1} sx={{ maxWidth: 345 }}>
          <Skeleton variant="rectangular" height={158} />
          <Skeleton />
          <Skeleton width="60%" />
        </Card>
      </Grid>
    ));
  };

  return (
    <>
      <Box className="wishlist">
        <Typography gutterBottom variant="h4" component="h2">
          Wishlist
        </Typography>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
        >
          {loading ? (
            skeletonLoader()
          ) : wishlist?.data?.length ? (
            wishlist.data.map((d, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Card
                  className="wishlist-card"
                  elevation={1}
                  sx={{ maxWidth: 345 }}
                >
                  <ButtonBase
                    className="wishlist-btn"
                    onClick={() => navigate(`/auth/home/view-profile/${d.id}`)}
                    elevation={1}
                    sx={{
                      maxWidth: 320,
                      height: 320,
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 2,
                      overflow: "hidden",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        height: "65%",
                        flexShrink: 0,
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={
                          d.image != null
                            ? d.image
                            : "https://gravatar.com/avatar/7dfcbd35cb010a2992a8cd85e566c2c8?s=400&d=mp&r=x"
                        }
                        alt={d.name}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          objectPosition: "center",
                          display: "block",
                          backgroundColor: "#f5f5f5",
                        }}
                      />
                    </Box>
                    <CardHeader
                      action={
                        <IconButton
                          aria-label="settings"
                          onMouseDown={(event) => event.stopPropagation()}
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            console.log("Button clicked", d);
                            shortListProfile(d.id, !d.is_liked);
                          }}
                        >
                          <FavoriteIcon
                            style={{
                              color: d.is_liked
                                ? "#D53833"
                                : "rgba(0, 0, 0, 0.54)",
                            }}
                          />
                        </IconButton>
                      }
                      title={
                        <Typography variant="subtitle1" component="h2">
                          {d.name}
                        </Typography>
                      }
                    />
                    <CardHeader
                      subheader={
                        <Typography variant="subtitle2" component="h2">
                          {d.age != null ? d.age : ""} yrs{" "}
                          {d.education != null ? d.education : ""}{" "}
                          {d.city != null ? d.city : ""}
                        </Typography>
                      }
                    />
                  </ButtonBase>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography
              variant="h6"
              component="p"
              className="wishlist-no-record"
            >
              No records found.
            </Typography>
          )}
        </Grid>
      </Box>
      <ToastContainer />
    </>
  );
};

export default WishList;
